// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[data-sl-search]>[data-sl-search-input]::placeholder {
  color: var(--sl-color-gray-6) !important;
}
`, "",{"version":3,"sources":["webpack://./src/modules/retailMedia/components/SubpublisherCatalogFilter/styles.css"],"names":[],"mappings":"AAAA;EACE,wCAAwC;AAC1C","sourcesContent":["[data-sl-search]>[data-sl-search-input]::placeholder {\n  color: var(--sl-color-gray-6) !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
